<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
    <el-col :span="colSpan">
      <el-form-item :label="$t('BusinessPurchaseBasics.code')" prop="code">
        <BjInput v-model="form.code" :disabled="isEdit" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="colSpan">
      <el-form-item :label="$t('BusinessPurchaseBasics.name')" prop="name">
        <BjInput v-model="form.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="colSpan">
      <el-form-item :label="$t('BusinessPurchaseBasics.value')" prop="data">
        <BjInput v-model="form.data" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>

    <el-col :span="colSpan">
      <el-form-item :label="$t('WarehouseManagement.form.Description')" prop="remarks">
        <BjInput v-model="form.remarks" clearable :placeholder="$t('inputText')"></BjInput>
      </el-form-item>
    </el-col>

    <el-col :span="colSpan">
      <el-form-item :label="$t('BusinessPurchaseBasics.type')" prop="type">
        <BjSelectLov v-model="form.type" lov-code="SPUR.PURCHASE_CONFIG" />
      </el-form-item>
    </el-col>

  </BjDrawerForm>
</template>
<script>
import { purchaseApi } from '@/api';

const getDefaultForm = () => {
  return {
    code: null,
    name: null,
    data: null,
    type: null,
    remarks: null
  };
};

export default {
  data() {
    return {
      colSpan: 24,
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      // 表单校验
      const rules = {
        code: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        data: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        type: [{required: true, message: this.$t('chooseText'), trigger: 'change'}]
      };
      return rules;
    }
  },
  watch: {},
  mounted() {
  },
  methods: {

    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('editText') : this.$t('addText'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      purchaseApi.addPurchaseConfig(API_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      purchaseApi.editPurchaseConfig(API_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
